import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {Harlequin} from "../../Harlequin";
import {SpinParsedGameData} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinParsedServerData";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {HarlequinSoundConfig} from "../../HarlequinSoundConfig";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";

export class HarlequinNearWin implements GameRoundPresentation {

    private readonly _reelId:number;
    private readonly _duration:number;
    private readonly _abortDuration:number;
    private _stopDelay:number;
    private _quickStopDelay:number;

    private _tl:TimelineLite;
    private _data:HarlequinParsedGameData;
    private _scatterPositions:number [] = [];
    private _inBaseGame:boolean = false;
    private _nearWinReels:boolean [];

    private _hasWild:boolean = false;
    private _aborted:boolean = false;
    private _freespinTriggeredThisSpin:boolean = false;

    private _stagger:number;
    private _abortStagger:number;

    private _soundTl:Timeline | null;
    private _soundStarted:boolean = false;


    constructor(reelId:number, duration:number, abortDuration:number, stagger?:number, abortStagger?:number) {
        this._reelId = reelId;
        this._duration = duration;
        this._abortDuration = abortDuration;
        this._stagger = stagger || 0;
        this._abortStagger = abortStagger || 0;

        this._stopDelay = Harlequin.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = Harlequin.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

    }

    prepare(data:ParsedServerData):void {
        this._data = <HarlequinParsedGameData> data;
        HarlequinGameModuleConfig.nearWinView.reset();
        this._aborted = false;
        this._soundStarted = false;
        this._scatterPositions = data.scatterPositions || [];
        this._inBaseGame = (data.mode === "NORMAL" || data.mode === "WILD_RESPIN");
        this._nearWinReels = this._data.nearWinReels;
        this._hasWild = (this._data.doReelNudge)? this._data!.doReelNudge[this._reelId] : false;
        this._freespinTriggeredThisSpin = this._data.freespinTriggeredThisSpin;
    }

    public getAnimation(data:SpinParsedGameData):Timeline | null { // TODO: Why spin parsed data?
        const soundTl:TimelineLite = new TimelineLite();
        this._stagger = GameSetting.isFastSpin ? this._quickStopDelay : this._stopDelay;

        /*if(this._nearWinReels[this._reelId]) {
            this._stagger += 2;
        }*/

        if((<SpinParsedGameData> this._data).nearWinReels[this._reelId]) {

            //this._tl = new TimelineLite();
            this._tl = Harlequin.timelineReelsController.startNearWin(this._reelId, this._duration);
            this._tl.add(() => {

                HarlequinGameModuleConfig.nearWinView.playOnReel(this._reelId);
                // Play anticipation loop if firts nw reel this spin
                if(this._nearWinReels[this._reelId] && !this._nearWinReels[this._reelId - 1]) {
                    if(!this._soundStarted) {
                        this._soundStarted = true;
                        if(this._reelId === 3 && this._data.wildOverlayReels[this._reelId -1]) {
                            // Skipping to start sound again, as it should already have started.
                        }
                        else {
                            SlotGame.sound.playEffect(HarlequinSoundConfig.instance.ANTICIPATION);
                        }
                    }
                }

                //if(this._nearWinReels[this._reelId] && this._data.wildOverlayReels[this._reelId] && !this._nearWinReels[this._reelId + 1]) {
                    // TODO: no
                    //SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.ANTICIPATION);
                //}

            }, 0.3);

            return this._tl;
        }

        return null;
    }

    public abort(isActive:boolean, data:SpinParsedGameData):Timeline | null {
        this._aborted = true;
        if((<SpinParsedGameData> this._data).nearWinReels[this._reelId]) {
            let duration:number = this._abortDuration;
            if(isActive) {
                duration = Math.max(0, this._abortDuration - this._tl.time());
            }
            //if(this._reelId === 4) {
            //HarlequinGameModuleConfig.nearWinView.reset();

            if(this._soundTl) {
                //this._soundTl.pause();
                //this._soundTl.kill();
            }
            //}
            const tl:TimelineLite = new TimelineLite();
            this._tl.timeScale(2);
            tl.add(this._tl, "+=0.7");
            return tl; //null; //Harlequin.timelineReelsController.startNearWin(this._reelId, duration);
        }
        else {
            HarlequinGameModuleConfig.nearWinView.reset();

            if(this._soundTl) {
                this._soundTl.pause();
                this._soundTl.kill();
            }
        }
        return null
    }

}